import { SET_A11Y_CONTENT } from "../actions/setA11yContent";

export default (
  state = {
    screenReaderMessage: "",
    title: "Verizon Privacy Dashboard",
    metaDescription:
      "Know what you share with us. Download your information, delete what's not necessary for service, and access privacy controls all from your dashboard."
  },
  { type, payload }
) => {
  switch (type) {
    case SET_A11Y_CONTENT:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};
